import React, { useEffect, useRef, useState } from "react";
import { clearDetail, setFogg, setSubTitle } from "../stores/AppReducer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, IApplicationState } from "../stores/AppStore";
import { ITankStation, ITankType, IUmkreis } from "../interfaces/Tanker";
import { getDetails, getFavorites, getStations, setFavorit } from "../services/tankerService";
import { IAppState } from "../interfaces/App";

function Tanker() {
    const app: IAppState = useSelector((appState: IApplicationState) => appState.app);
    const dispatch = useDispatch<AppDispatch>();
    const times = useRef(0);
    const initUmkreis: IUmkreis = {
        lat: "54.18629",
        lng: "12.98881",
        rad: 20,
        sort: "dist",
        type: app.tanker.type
    };
    const [umkreis, setUmkreis]  = useState(initUmkreis);
    const [sortby, setSortby] = useState("dist");
    useEffect(() => {
        if (times.current++ === 0) {
            dispatch(setSubTitle("Tanken"));
            navigator.geolocation.getCurrentPosition((pos) => {
                setUmkreis({...umkreis, lat: String(pos.coords.latitude), lng: String(pos.coords.longitude)});
            });
            listFavorites();
        }
    }, []);
    // useEffect(() => {

    // }, [sortby]);
    const listFavorites = () => {
        dispatch(setFogg(true));
        dispatch(getFavorites(app.user.id) as unknown as any).then(() => dispatch(setFogg(false)));
    };
    const listStations = (ev: any) => {
        ev.preventDefault();
        dispatch(setFogg(true));
        dispatch(getStations(umkreis) as unknown as any).then(() => dispatch(setFogg(false)));
    };
    const Details = (id: string) => {
        if (app.tanker.stationDetail) {
            dispatch(clearDetail());
        } else {
            dispatch(getDetails(id) as unknown as any);
        }
    };
    const handleFavorit = (id: string, fav: boolean) => {
        const isFavorit = (fav ? false : true);
        dispatch(setFavorit({id, userId: app.user.id,  isFavorit}))
    };
    const sortBy = (s1: ITankStation, s2: ITankStation): number => {
        if (sortby === "price") {
            if (s1.price > s2.price) {return 1};
            if (s1.price < s2.price) {return -1};
        } else {
            if (s1.dist > s2.dist) {return 1};
            if (s1.dist < s2.dist) {return -1};            
        }
        return 0;
    };
    const renderStations = (s: ITankStation, n: number) => {
        const ifDedail = (app.tanker.stationDetail?.id === s.id) ? true : false;
        return ifDedail ? (
            <tr key={"station_" + n}  onClick={() => Details(s.id)} >
                <td>
                    {s.brand} {s.name}, {s.street}, {s.place}
                </td>
                <td>{s.dist}</td>
                <td>{s.price}</td>
                <td>{s.isOpen ? "" : "Geschlossen"}</td>
            </tr>
        ) : (
            <tr key={"station_" + n} onClick={() => Details(s.id)}  >
                <td>
                    {s.brand}
                </td>
                <td>{s.dist}</td>
                <td>{s.price}</td>
                <td>{s.isOpen ? "Offen" : "Geschl."}</td>
                <td
                    onClick={(ev: any) => ev.stopPropagation()}
                ><input
                    type="checkbox"
                    value={s.favorit ? 1 : 0}
                    checked={s.favorit}
                    onChange={(ev: any) => {ev.stopPropagation(); handleFavorit(s.id, s.favorit)}}
                    />
                </td>
            </tr>
        );
    };
    return (
        <div>
            <form onSubmit={(ev: any) => listStations(ev)}>
                <div className="tankPanel">
                    <input name="lat" type="hidden" value = {umkreis.lat} onChange={(ev: any) => setUmkreis({...umkreis, lat: ev.target.value})} className="lat"/>
                    <input name="lng" type="hidden" value = {umkreis.lng} onChange={(ev: any) => setUmkreis({...umkreis, lng: ev.target.value})} className="lng"/>

                    <label htmlFor="rad">Umkreis (km)</label>
                    <input name="rad" value = {umkreis.rad} onChange={(ev: any) => setUmkreis({...umkreis, rad: ev.target.value})} className="rad"/>
                    <select
                        name="type"
                        onChange={(ev: any) => setUmkreis({...umkreis, type: ev.target.value})}
                        value={umkreis.type}
                        className="type"
                    >
                        <option value={ITankType.e5}>E5</option>
                        <option value={ITankType.e10}>E10</option>
                        <option value={ITankType.diesel}>Diesel</option>
                    </select>
                    <button type="submit" className="unkreis">
                        Ok
                    </button>
                    <button 
                        onClick={(ev: any) => {ev.preventDefault(); ev.stopPropagation(); listFavorites()}}
                        className="favorit"
                    >
                        Fav
                    </button>
                </div>
            </form>
            <table className="tankList">
                <tbody>
                    <tr>
                        <th>Marke</th>
                        <th onClick={() => setSortby("dist")}>km</th>
                        <th onClick={() => setSortby("price")}>Preis</th>
                    </tr>
                    {app.tanker.stations?.length > 0 && [...app.tanker.stations].sort(sortBy).map(renderStations)}
                </tbody>
            </table>
        </div>
    );
}
export default Tanker;
